module.exports = __webpack_public_path__ + "static/media/window-alt.31dd5f64.svg";